(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/pay-numbergames/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/components/numbergames/pay-numbergames/assets/javascripts/prescript.js');

'use strict';

svs.numbergames = svs.numbergames || {};
svs.numbergames.pay_numbergames = svs.numbergames.pay_numbergames || {};
svs.numbergames.pay_numbergames.data = svs.numbergames.pay_numbergames.data || {};
svs.numbergames.pay_numbergames.logger = new svs.core.log.Logger('numbergames:pay');

 })(window);